import { MEDIA_QUERY_MOBILE_DOWN } from 'utils/constants/breakpoints';
import { defineMessage, FormattedMessage, useIntl } from '@alltrails/shared/react-intl';
import Typography from 'components/Typography';
import StarRating from 'components/shared/StarRating';
import AppStore from '@alltrails/shared/components/storeBadges/AppStore';
import GooglePlay from '@alltrails/shared/components/storeBadges/GooglePlay';
import PlusBadge from '@alltrails/shared/denali/components/PlusBadge';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import bgImageSrcAvif from '../../../../assets/images/welcome/ratingAndReview/person-running.avif';
import bgImageSrcWebp from '../../../../assets/images/welcome/ratingAndReview/person-running.webp';
import bgImageSrc from '../../../../assets/images/welcome/ratingAndReview/person-running.jpg';
import bgImageSrcMobileAvif from '../../../../assets/images/welcome/ratingAndReview/person-running-mobile.avif';
import bgImageSrcMobileWebp from '../../../../assets/images/welcome/ratingAndReview/person-running-mobile.webp';
import bgImageSrcMobile from '../../../../assets/images/welcome/ratingAndReview/person-running-mobile.jpg';
import * as styles from './styles/styles.module.scss';
import editorsChoiceSrc from '../../../../assets/images/welcome/ratingAndReview/apple-editors-choice.jpg';
import appDownloadCodeSrc from '../../../../assets/images/welcome/ratingAndReview/pro-signup-code.png';

const imageAltTextMessage = defineMessage({
  defaultMessage: 'Person jogging on a trail.'
});

const AppDownloadAndReview = () => {
  const languageRegionCode = useLanguageRegionCode();
  const intl = useIntl();
  const imageAltText = intl.formatMessage(imageAltTextMessage);

  return (
    <div className={styles.container}>
      <div className={styles.appSectionContainer}>
        <div className={styles.appRatingContainer}>
          <img className={styles.editorsChoiceImage} src={editorsChoiceSrc} alt="Apple editor's choice" loading="lazy" />
          <Typography variant="paragraph300" className={styles.ratingValue}>
            4.9
          </Typography>
          <StarRating config={5} />
        </div>
        <Typography variant="heading600" component="h2" className={styles.header}>
          <FormattedMessage defaultMessage="Find your way outside" />
        </Typography>
        <div className={styles.storeBadgeContainer}>
          <AppStore height={40} languageRegionCode={languageRegionCode} />
          <GooglePlay height={40} languageRegionCode={languageRegionCode} />
        </div>
        <div className={styles.downloadCodeContainer}>
          <img className={styles.codeImage} src={appDownloadCodeSrc} alt="app download code" loading="lazy" />
          <Typography variant="text100">
            <FormattedMessage defaultMessage="Download the app for Android or iOS" />
          </Typography>
        </div>
      </div>
      <div className={styles.testimonialSectionContainer}>
        <picture>
          <source media={MEDIA_QUERY_MOBILE_DOWN} srcSet={bgImageSrcMobileAvif} type="image/avif" />
          <source media={MEDIA_QUERY_MOBILE_DOWN} srcSet={bgImageSrcMobileWebp} type="image/webp" />
          <source media={MEDIA_QUERY_MOBILE_DOWN} srcSet={bgImageSrcMobile} type="image/jpg" />
          <source srcSet={bgImageSrcAvif} type="image/avif" />
          <source srcSet={bgImageSrcWebp} type="image/webp" />
          <img className={styles.bgImage} src={bgImageSrc} loading="lazy" alt={imageAltText} />
        </picture>
        <div className={styles.dialogBoxContainer}>
          <div className={styles.ratingContainer}>
            <Typography variant="paragraph300" className={styles.ratingValue}>
              5/5
            </Typography>
            <StarRating config={5} />
          </div>
          <Typography variant="paragraph200" className={styles.description}>
            <FormattedMessage defaultMessage="The AllTrails+ app is my go to for planning and tracking all our hiking adventures. From epic backpacking trips to local trails it’s my number one recommended hiking tool! The dog-friendly filter makes it so easy to find the best trails for my whole family to enjoy." />
          </Typography>
          <div className={styles.reviewerContainer}>
            <Typography variant="paragraph200" className={styles.reviewer}>
              Breanne S.
            </Typography>
            <PlusBadge />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppDownloadAndReview;
